<template>
    <div class="container-render-post">
    <div class="render-post render-post-tiktok" :class="scrollbarClass" :style="{ fontSize: fontSize + 'px' }" ref="render-post">
        <div class="header-app">
            Pour toi
        </div>
        <div class="music-pill" v-if="music && music.track">
            <i class="fa-solid fa-music-note"></i>
            <span class="music-pill-text">{{ music.track.title }}</span>
        </div>
        <div class="post-content" @click="clickOnPost">
            <template v-if="isVideoPost">
                <video
                    ref="video"
                    :autoplay="true"
                    loop
                    playsinline
                    crossorigin="anonymous"
                    preload="metadata"
                    :muted="videoMuted"
                    :src="medias[0].url"
                    :type="medias[0].type"
                    :class="{'cover': medias[0].info.aspectRatio <= 0.5625}"
                    @ended="onVideoLoop"
                ></video>
                <AudioPlayer
                    v-if="music && music.track"
                    ref="musicAudio"
                    :src="music.track.progressive_download_url"
                    :start="parseInt((music.start || 0) / 1000)"
                    :duration="parseInt((music.duration || 15000) / 1000)"
                    :loop="true"
                    :volume="musicVol"
                />
            </template>
            <template v-else-if="medias.length">
                <div class="carousel" :class="{singleMedia: medias.length == 1}">
                    <Carousel :perPage="1" :adjustableHeight="true" :centerMode="true" :paginationEnabled="true" :navigationEnabled="false">
                        <Slide v-for="media in medias.slice(0,20)" :key="media.id">
                            <div class="item">
                                <img :src="media.url">
                            </div>
                        </Slide>
                    </Carousel>
                </div>
            </template>

            <div class="nav-lateral">
                <div class="page" @click="pages.length == 1 && openTiktokPage(pages[0])">
                    <img :src="pages && pages.length ? pages[0].avatar : 'img/avatar.jpg'" alt="">
                    <div class="page count" v-if="pages.length > 1">
                        +{{ pages.length }}
                    </div>
                    <i class="fa-solid fa-plus"></i>
                </div>
                <div class="like">
                    <svg height="auto" width="auto" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 2.25C10.5 2.25 12 4.25 12 4.25C12 4.25 13.5 2.25 16.5 2.25C20 2.25 22.5 4.99999 22.5 8.5C22.5 12.5 19.2311 16.0657 16.25 18.75C14.4095 20.4072 13 21.5 12 21.5C11 21.5 9.55051 20.3989 7.75 18.75C4.81949 16.0662 1.5 12.5 1.5 8.5C1.5 4.99999 4 2.25 7.5 2.25Z"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.40179 12.1998C3.58902 14.6966 5.7592 16.9269 7.74989 18.75C9.5504 20.3989 10.9999 21.5 11.9999 21.5C12.9999 21.5 14.4094 20.4072 16.2499 18.75C19.231 16.0657 22.4999 12.5 22.4999 8.49997C22.4999 8.41258 22.4983 8.32566 22.4952 8.23923C20.5671 13.6619 13.6787 18.5 11.75 18.5C10.3127 18.5 5.61087 15.8131 2.40179 12.1998Z" fill-opacity="0.03"></path>
                    </svg>
                </div>
                <div class="comment">
                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 48 48" fill="currentColor">
                        <path fill-rule="evenodd" d="M2 21.5c0-10.22 9.88-18 22-18s22 7.78 22 18c0 5.63-3.19 10.74-7.32 14.8a43.6 43.6 0 0 1-14.14 9.1A1.5 1.5 0 0 1 22.5 44v-5.04C11.13 38.4 2 31.34 2 21.5M14 25a3 3 0 1 0 0-6 3 3 0 0 0 0 6m10 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6m13-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0" clip-rule="evenodd"></path>
                    </svg>
                </div>
                <div class="favori">
                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M4 4.5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v15.13a1 1 0 0 1-1.555.831l-6.167-4.12a.5.5 0 0 0-.556 0l-6.167 4.12A1 1 0 0 1 4 19.63z"></path>
                        <path d="M4.032 4.144Q4 4.317 4 4.5v15.13a1 1 0 0 0 1.555.831l6.167-4.12a.5.5 0 0 1 .41-.066l-.427-.198a1.49 1.49 0 0 0-1.377.063c-.581.339-1.45.85-2.25 1.339-.59.359-1.427.695-2.187.962-.929.325-1.86-.387-1.86-1.37zm8.251 12.202 6.162 4.115A1 1 0 0 0 20 19.63V4.5a2 2 0 0 0-1.123-1.798c.21.254.334.58.33.936a117 117 0 0 1-.896 13.408c-.124.99-1.17 1.553-2.076 1.133z"></path>
                    </svg>
                </div>

                <div class="share">
                    <svg xmlns="http://www.w3.org/2000/svg" height="auto" width="auto" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M10.938 3.175a.674.674 0 0 1 1.138-.488l6.526 6.215c.574.547.554 1.47-.043 1.991l-6.505 5.676a.674.674 0 0 1-1.116-.508V13.49s-6.985-1.258-9.225 2.854c-.209.384-1.023.518-.857-1.395.692-3.52 2.106-9.017 10.082-9.017z" clip-rule="evenodd"></path>
                        <path d="m15.754 6.212 1.295 2.59a1.12 1.12 0 0 1-.268 1.349l-5.799 5.042s-.28 1.403.562 1.403 7.578-6.174 7.578-6.174.28-.842-.561-1.684c-.843-.842-2.807-2.526-2.807-2.526" clip-rule="evenodd" opacity=".03"></path>
                        <path  d="M10.937 6.23v7.297s-6.683-.942-8.777 2.246C.146 18.839.331 12.309 3.363 9.057s7.574-2.827 7.574-2.827"></path>
                    </svg>
                </div>
            </div>
            <div class="info-post">
                <div class="page">
                    <div class="names">
                        <p class="page-name" v-if="pages.length <= 1" @click="openTiktokPage(pages[0])">{{ pages[0].name }}</p>
                    </div>
                </div>
                <div class="description-video" v-if="isVideoPost" :class="{'cut-content': !fullContent}" @click.stop="toggleFullContent" v-html="titleTranslate + '<br />' + textTranslate"></div>


                
                <!-- <div class="description-video see-more" v-if="!fullContent && isVideoPost" @click.stop="toggleFullContent">
                    Voir plus
                </div> -->
                <div class="post-title" v-if="hasPhotos">
                    <p v-html="titleTranslate || 'Titre'"></p>
                </div>
                <div 
                    class="post-description" 
                    v-if="hasPhotos" 
                    :class="{'cut-content': !fullContent}" 
                    @click.stop="toggleFullContent"
                    v-html="textTranslate || 'Description'"
                >
                </div>
            </div>

            <div :key="videoMuted ? 'no-sound' : 'sound'" :class="videoMuted ? 'no-sound' : 'sound'"></div>
        </div>
    </div>
    <SelectMusicTiktok v-if="modes.includes('addTiktokMusicMode')"
        @close="closeContentOverflow"
        :musicSelected="music"
        :position="positionFormOverlay"
        :videoDurationMs="videoDurationMs"
    />
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import { EventBus } from '@/event-bus';
    import renderPostMixin from '../../../mixins/renderPost';
    import SelectMusicTiktok from '../../formOverlay/selectMusicTiktok.vue';
    import AudioPlayer from '../../audioPlayer.vue';

    export default {
        mixins: [renderPostMixin],
        components: {
            Carousel,
            Slide,
            SelectMusicTiktok,
            AudioPlayer
        },

        props: {
            pages: {
                type: Array,
                default: ()=>[]
            },
            title: {
                type: String,
                default: ''
            },
            text : {
                type: String,
                default: ''
            },
            medias: {
                type: Array,
                default: () => []
            },
            mentions : {
                type: Object,
                default: ()=>({})
            },
            modes: {
                type: Array,
                default: () => []
            },
            music: {
                type: Object,
                default: undefined
            },
            positionFormOverlay: {
                type: Object,
                default: () => ({})
            },
        },

        data() {
            return {
                videoMuted: true,
                fullContent: false,
            }
        },

        mounted() {
            this.$nextTick(() => this.applyVideoVolume())
        },

        watch: {
            videoVol() { this.applyVideoVolume() },
            'music.track.progressive_download_url'() { this.$nextTick(() => this.applyVideoVolume()) }
        },

        methods: {
            openTiktokPage(page) {
                const url = `https://www.tiktok.com/@${page.name}/`;
                window.open(url, '_blank');
            },

            toggleFullContent() {
                this.fullContent = !this.fullContent;
            },

            clickOnPost(e) {
                if (this.fullContent) {
                    this.fullContent = false;
                    return;
                }
                if (this.isVideoPost) {
                    this.videoMuted = !this.videoMuted;
                }
             
            },

            closeContentOverflow() {
                EventBus.$emit('postCreatorRemoveMode', 'all')
            },

            applyVideoVolume() {
                const v = this.$refs.video
                if (!v) return
                v.volume = this.videoVol
                v.muted = this.videoVol === 0
            },

            onVideoLoop() {
                const ap = this.$refs.musicAudio
                if (ap && ap.$refs && ap.$refs.audio) {
                    ap.$refs.audio.currentTime = (this.music && this.music.start ? this.music.start : 0) / 1000
                }
            },
        },

        computed: {

            hasPhotos() {
                return this.medias.some(media => media.type.startsWith('image/'));
            },

            isVideoPost() {
                return !this.hasPhotos && this.medias.length && this.medias[0].type.startsWith('video/')
            },

            videoDurationMs() {
                if (!this.medias || !this.medias.length) return 0
                const info = this.medias[0].info
                if (!info || !info.duration) return 0
                return Math.round(info.duration * 1000)
            },

            videoVol() {
                if (this.videoMuted) return 0
                if (!this.music || !this.music.track) return 1
                const balance = this.music.balance !== undefined ? this.music.balance : 0
                return Math.max(0, (1 - balance) / 2)
            },

            musicVol() {
                if (this.videoMuted) return 0
                if (!this.music || !this.music.track) return 0
                const balance = this.music.balance !== undefined ? this.music.balance : 0
                return Math.max(0, (1 + balance) / 2)
            },

            titleTranslate() {
                //return this.text
                return this.title.substring(0,2200).replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.tiktok ? `<span class="mention">@${mention.mention.tiktok.unique_id || mention.mention.tiktok.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');

            },

            textTranslate() {
                //return this.text
                return this.text.substring(0,2200).replace(/#[\wÀ-ÿ]+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.tiktok ? `<span class="mention">@${mention.mention.tiktok.unique_id || mention.mention.tiktok.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },
        },

        
    }
</script>
